import {
  STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER,
  STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_SUCCESS,
  STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_FAILURE,
  STATSIG_GET_EVENT_DATA_FOR_CLEAR_ERROR,
  STATSIG_SET_TRACK_ANONYMOUS_USERS,
} from '../actions/actionTypes/statsig-action-types';

const initialState = {
  eventDataForStatsig: {
    loading: false,
    error: null,
    data: null,
  },
  trackAnonymousUsers: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER: {
      return {
        ...state,
        eventDataForStatsig: {
          loading: true,
          error: false,
          data: null,
        },
      };
    }
    case STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_SUCCESS: {
      const event = action.payload;
      return {
        ...state,
        eventDataForStatsig: {
          loading: false,
          error: false,
          data: {
            eventId: event.id,
            clubId: event.clubId,
            sportTypeId: event.sportTypeId,
          },
        },
      };
    }
    case STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_FAILURE: {
      return {
        ...state,
        eventDataForStatsig: {
          loading: false,
          error: true,
          data: null,
        },
        redirectUrl: action.payload?.redirectUrl,
        errorMessage: action.payload.errorMessage,
      };
    }
    case STATSIG_GET_EVENT_DATA_FOR_CLEAR_ERROR: {
      return {
        ...state,
        eventDataForStatsig: {
          error: false,
        },
        redirectUrl: null,
        errorMessage: null,
      };
    }
    case STATSIG_SET_TRACK_ANONYMOUS_USERS: {
      return {
        ...state,
        trackAnonymousUsers: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
